import { STARTER, PROFESSIONAL, ENTERPRISE } from 'self-service-api/constants/ProductLevels';
import { CRM_SUITE_STARTER, CRM_SUITE_PROFESSIONAL, CRM_SUITE_ENTERPRISE } from './NonMerchandiseIdIdentifers'; // These are used ONLY for tracking and to attach to nodes for acceptance test purposes

const SuiteNonMerchandiseIdMap = {
  [STARTER]: CRM_SUITE_STARTER,
  [PROFESSIONAL]: CRM_SUITE_PROFESSIONAL,
  [ENTERPRISE]: CRM_SUITE_ENTERPRISE
};
export default SuiteNonMerchandiseIdMap;